import React, { useState } from 'react';

export default function Checkbox(props) {
  const { id, name, value, label, checked, handleChange, variation, small } = props;
  const onChange = e => {
    handleChange?.(e);
  };

  return (
    <div className={`form-checkbox__wrapper${variation ? ` form-checkbox--${variation}` : ''}${small ? ' form-checkbox--small' : ''}`}>
      <label htmlFor={id} className="form-checkbox">
        <input
          className="form-checkbox__input"
          type="checkbox"
          name={name}
          value={value}
          checked={checked}
          id={id}
          onChange={onChange}
        />
        <div className="checkmark__wrapper" role="presentation">
          <svg className="checkmark__svg" viewBox="0 0 120 120">
            <use xlinkHref="#checkmark-regular"></use>
          </svg>
        </div>
        <span className="label">{label}</span>
      </label>
      <p className="form-input__error">error</p>
    </div>
  );
}
